export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '韩国伦理文化的核心是什么？',
    answer: '韩国伦理文化的核心是儒家思想基础之上的集体主义价值观。以"忠孝仁义"为基本框架，强调家庭纽带、长幼有序、社会和谐与个人对集体的责任。同时，韩国伦理文化在现代进程中不断吸收民主、平等、人权等普世价值，形成了传统与现代交融的独特伦理体系。',
  },
  {
    question: '儒家伦理在当代韩国社会中还有多大影响力？',
    answer: '儒家伦理在当代韩国社会中仍然具有深远的影响力，但其表现形式已经从显性的制度规范转变为隐性的文化心理。在教育热忱、家庭关系、职场等级、社交礼仪、祭祀传统等方面，儒家伦理的价值取向仍然清晰可见。不过，年轻一代对这些传统的认同度和实践方式正在发生变化。',
  },
  {
    question: '韩国职场文化有什么独特的伦理规范？',
    answer: '韩国职场的独特伦理规范包括：严格的上下级等级制度（体现在语言使用、决策流程和日常互动中）；"会食"（公司聚餐）文化作为团队凝聚的重要仪式；对资历和年龄的高度重视（有时超过对能力的考量）；以及"加班文化"所体现的对公司忠诚度的期待。不过，近年来这些规范正在经历显著的改革。',
  },
  {
    question: '韩国影视作品如何反映社会伦理议题？',
    answer: '韩国影视作品以其对社会伦理问题的尖锐剖析而著称。从奉俊昊的《寄生虫》对阶级不平等的揭示，到《鱿鱼游戏》对债务经济和人性边界的探讨，再到《82年生的金智英》对性别歧视的批评，韩国影视工作者善于通过类型化的叙事手法，将复杂的社会伦理议题转化为触动人心的故事，引发广泛的社会讨论。',
  },
  {
    question: '韩国家庭伦理正在经历哪些变化？',
    answer: '韩国家庭伦理正在经历深刻转型：传统的大家庭制度已基本瓦解，核心家庭成为主流；孝道的实践方式从"同居赡养"转向"经济支持+定期探望"；婚姻观念从"必须结婚"转向"选择结婚"；性别角色期待趋于平等，但实际家务分工仍存在差距。这些变化反映了韩国社会从传统农业伦理向现代工业伦理的整体转型。',
  },
  {
    question: '如何理解韩国社会的"情"（정）文化？',
    answer: '"情"（정）是韩国伦理文化中一个独特而核心的概念，指的是一种基于长期共处和相互扶持而产生的深厚情感纽带。它不同于西方概念中的"爱"（love）——"情"更强调时间积累和相互义务。在韩国社会中，"情"不仅存在于家庭和友谊关系中，也延伸到职场和社区中，是维系社会凝聚力的重要情感基础。理解"情"文化，是理解韩国人际关系伦理的关键。',
  },
  {
    question: '韩国伦理文化与日本、中国有何异同？',
    answer: '韩国、日本和中国同属儒家文化圈，在伦理观念上有诸多相似之处：重视家庭、强调教育、尊重权威、注重人际关系等。但三国之间也存在显著差异：韩国伦理更突出"情"（정）的情感维度，日本伦理更强调"义理"（ぎり）和"耻"文化，中国伦理则在家族主义和关系主义方面有更鲜明的特点。这些差异源于各国不同的历史发展路径和社会结构。',
  },
  {
    question: '外国人如何更好地理解和适应韩国伦理文化？',
    answer: '理解和适应韩国伦理文化需要从几个方面入手：学习基本韩语，特别是理解敬语体系的伦理含意；尊重年龄和资历，在社交场合注意长幼次序；理解"我们"（우리）文化的集体取向，避免过度的个人主义表达；在职场中适应间接沟通方式，学会"读懂氛围"（눈치）；参与集体活动（如会食）是建立关系的重要途径；最重要的是保持开放和尊重的心态，用"情"（정）来建立真诚的人际关系。',
  },
];